module.exports = __webpack_public_path__ + "img/warning-icon.c4022585.png";